import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * className merger used by every component in src/ui.
 * Combines clsx (conditional classes) with tailwind-merge (dedupes
 * conflicting Tailwind utilities so `cn("px-4", "px-6")` correctly
 * collapses to `px-6`).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
